import React, { useState, useEffect } from 'react';
import {
  storage,
  firestore,
  getPagingLawyers,
} from '../../configs/environments/firebase/firebaseApp';
import NormalCard from '../../components/CardLawyer/NormalCard';
import NoResults from './NoResults';
import BannerH from '../../components/Banners/BannerH';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import { connect } from 'react-redux';
import {
  pagingLaywers,
  process_laywer_users,
  lawyersEmpty,
} from '../../store/actions/LaywerUserAction';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import ScrollToTop from '../../components/ScrollToTop';
import { useParams } from 'react-router-dom';
import './findLawyer.scss';

var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const styles = () => ({});

const ListLaywers = (props) => {

  const { specialty, subSpeciality, state } = useParams()
  
  useEffect(() => {
    if (window.previousLawFirmLocation) {
      props.hideLoading();
      console.log('previous', window.previousLawFirmLocation);
    }else{
      fetchMyAPI();
      props.hideLoading();
    }
  }, []);

  function fetchMyAPI() {
    props.showLoading();
    props.process_laywer_users(props.role, 1, specialty, subSpeciality, state)
      .then(res=> {
        props.hideLoading();
      })
  }

  const handleChangePage = (event, value) => {
    props.showLoading()
    props.process_laywer_users(
      props.role,
      value,
      specialty,
      subSpeciality,
      state
    )
    .then(res=> {
      props.hideLoading();
      window.scrollTo(0,0)
    })
  };

  const handleDataPage = () => {
    return (
      <>
        {props.laywerData &&
          props.laywerData.data &&
          props.laywerData.data.length > 0 &&
          props.laywerData.data.map((layers) => {
            return (
              <div key={layers.uid} style={{ maxWidth: 824 }}>
                <NormalCard user={layers} />
              </div>
            );
          })}
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <Pagination
            color="primary"
            count={props.laywerData && props.laywerData.totalPages}
            page={props.laywerData && props.laywerData.actualpage}
            onChange={handleChangePage}
          />
        </div>
      </>
    );
  };

  const handleEmtyPage = () => (
    props.lawyersEmpty(props.role),
    <>
      <NoResults params={{
        specialty: props.specialty,
        state: props.stateSite
      }} />
      {props.laywerEmpty && props.laywerEmpty.data &&
        props.laywerEmpty.data.length > 0 &&
        props.laywerEmpty.data.map((layers) => {
          props.hideLoading()
          return (
            <div key={layers.uid} style={{ maxWidth: 824 }}>
              <NormalCard user={layers} />
            </div>
          );
        })
      }
    </>
  )

  return (
    props.laywerData.data && props.laywerData.data.length > 0 ? handleDataPage() : handleEmtyPage()
  )

}

const mapStateToProps = state => ({
  laywerData: state.paginationReducer.laywerData,
  laywerEmpty: state.paginationReducer.laywerEmpty
});

const mapDispatchToProps = dispatch => ({
  pagingLaywers: (role, page, specialty, stateSite) => dispatch(pagingLaywers(role, page, specialty, stateSite)),
  process_laywer_users: (role, page, specialty, subSpeciality, state) => dispatch(process_laywer_users(role, page, specialty, subSpeciality, state)),
  lawyersEmpty: role => dispatch(lawyersEmpty(role)),  
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(ListLaywers)));
